import { RsValue } from '../../../models/base/BaseModel';
import {
  IOvertimeParam,
  IOvertimeResult,
  IOvertimeUpdateParam,
} from '../../../models/overtime/OvertimeModel';
import api from '../../axios';

export const overtimeService = {
  listOvertimes: (
    params?: any
  ): Promise<{ rows: IOvertimeResult[]; lastRow: number; count: number }> =>
    api.get('/odata/Overtime', params),
  createOvertime: (data: IOvertimeParam): Promise<RsValue<IOvertimeResult>> =>
    api.post('/Overtime', data),
  updateOvertime: (id: number, data: IOvertimeUpdateParam): Promise<RsValue<IOvertimeResult>> =>
    api.put(`/Overtime/${id}`, data),
  deleteOvertime: (id: number): Promise<RsValue<boolean>> => api.delete(`/Overtime/${id}`),
  getOvertimeById: (id: number): Promise<RsValue<IOvertimeResult>> => api.get(`/Overtime/${id}`),
  getUserOvertimes: (userId: number): Promise<IOvertimeResult[]> =>
    api.get(`/Overtime/user/${userId}`),
};
